/**
 * Dialogen för "Exportera" i Affärer–Pipeline: antal leads och om
 * kontaktfotona ska bäddas in (standard av, för att hålla filen liten).
 */
import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
  FormControlLabel, Checkbox, Box,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function ExportDialog({ open, antal, onClose, onExportera }) {
  const [medFoton, setMedFoton] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <FileDownloadIcon sx={{ color: '#FF6B00' }} />
        <Box>
          <Typography variant="h6" fontWeight="bold">Exportera till Excel</Typography>
          <Typography variant="caption" color="text.secondary">
            {antal} filtrerade {antal === 1 ? 'lead' : 'leads'} med kunder och kontakter
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={<Checkbox checked={medFoton} onChange={e => setMedFoton(e.target.checked)}
            sx={{ '&.Mui-checked': { color: '#FF6B00' } }} />}
          label="Ta med kontaktfoton" />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ml: 4, mt: -0.5 }}>
          Foto i första kolumnen på fliken Kontakter. Kundlogotyperna kommer alltid med.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: 'text.secondary' }}>Avbryt</Button>
        <Button variant="contained" startIcon={<FileDownloadIcon />} onClick={() => onExportera({ medFoton })}
          sx={{ bgcolor: '#FF6B00', '&:hover': { bgcolor: '#e55a00' }, fontWeight: 700 }}>
          Exportera
        </Button>
      </DialogActions>
    </Dialog>
  );
}
